
// region JS Imports

// region External Modules
import $ from "jquery"

import { EventEmitter } from "events"
// endregion External Modules

// region Private Modules
import {
  onClickOutside,
} from "plugins/vanilla-clickout"
import dayjs from "plugins/dayjs"
import I18n from "plugins/i18n-js"
// endregion Private Modules

// region Public Components
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


interface Selector {
  scope:           string
  main:            string
  menu:            string
  toggle:          string
  dropdown_label:  string

  period_comparison_option: string
}

interface InputSelector {
  scope?:           string
  main?:            string
  menu?:            string
  toggle?:          string
  dropdown_label?:  string

  period_comparison_option?: string
}

const DEFAULT_SELECTOR = {
  scope:          ".page--building-level-real-estate-transactions-page--compare-section-desktop",
  main:           ".page--building-level-real-estate-transactions-page--compare-section-desktop-period_comparison",
  menu:           ".page--building-level-real-estate-transactions-page--compare-section-desktop-period_comparison_dropdown",
  toggle:         ".page--building-level-real-estate-transactions-page--compare-section-desktop-period_comparison-toggle",
  dropdown_label: ".page--building-level-real-estate-transactions-page--compare-section-desktop-period_comparison-toggle-text",

  period_comparison_option: ".page--building-level-real-estate-transactions-page--compare-section-desktop-period_comparison-option",
}


class PeriodComparisonSelectMenu extends EventEmitter {
  protected selector: Selector

  protected $scope:           JQuery
  protected $main:            JQuery
  protected $menu:            JQuery
  protected $toggle:          JQuery
  protected $dropdown_label:  JQuery

  protected $period_comparison_option:  JQuery


  constructor(selector?: InputSelector){
    super()

    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)

    this.$scope = $(this.selector.scope)
    this.$main = this.$scope.find(this.selector.main)
    this.$menu = this.$scope.find(this.selector.menu)
    this.$toggle = this.$main.find(this.selector.toggle)
    this.$dropdown_label = this.$main.find(this.selector.dropdown_label)

    this.$period_comparison_option = this.$scope.find(this.selector.period_comparison_option)

    this.bind_action()
  }

  protected bind_action(){
    this.$toggle.on("click", () => {
      if ( this.$main.hasClass("disabled") ) {
        return
      }

      if (this.$menu.hasClass("active")) {
        this.$menu.removeClass("active")
      }
      else {
        this.$menu.addClass("active")
      }
    })

    this.$period_comparison_option.on("click", (e) => {
      this.$menu.removeClass("active")

      if ( this.$main.hasClass("disabled") ) {
        return
      }

      if ( $(e.currentTarget).hasClass("selected") && this.$main.hasClass("with-data--selected") ) {
        return
      }

      this.$period_comparison_option.removeClass("selected")
      $(e.currentTarget).addClass("selected")

      this.updateButtonStyle($(e.currentTarget))
      this.update_button_text()

      this.emit("val_change")
    })

    onClickOutside(this.$main[0] as HTMLElement, () => {
      this.$menu.removeClass("active")
    })
  }

  protected updateButtonStyle($current_option: JQuery<HTMLElement>){
    if ( $current_option.attr("data") === "none" ) {
      this.$main.removeClass("with-data--selected")
    }
    else {
      this.$main.addClass("with-data--selected")
    }
  }

  protected calculate_compared_date(compare_option_value: string, original_date: Date, year_diff: number, month_diff: number) {
    if ( compare_option_value === "year" ) {
      return new Date(original_date.getFullYear() - 1, original_date.getMonth(), 1)
    }
    else {
      return new Date(original_date.getFullYear() - year_diff, original_date.getMonth() - month_diff, 0)
    }
  }

  protected custom_compared_period_text(compare_option_value: string, selected_period_text_array: string[]) {
    const selected_start_date = dayjs(selected_period_text_array[0].trim(), "MM/YYYY").toDate()
    const selected_end_date = dayjs(selected_period_text_array[1].trim(), "MM/YYYY").toDate()

    const year_diff = selected_end_date.getFullYear() - selected_start_date.getFullYear()
    const month_diff = selected_end_date.getMonth() - selected_start_date.getMonth()

    const compared_end_date = this.calculate_compared_date(compare_option_value, selected_end_date, year_diff, month_diff)
    const compared_start_date = this.calculate_compared_date(compare_option_value, selected_start_date, year_diff, month_diff)

    return `${dayjs(compared_start_date).format("MM/YYYY")} - ${dayjs(compared_end_date).format("MM/YYYY")}`
  }

  public selected_value() {
    if (this.$main.hasClass("disabled")) {
      return "none"
    }
    else {
      return this.$period_comparison_option.filter(".selected").attr("data") as string
    }
  }

  public reset() {
    this.$main.removeClass("with-data--selected")

    this.$period_comparison_option.removeClass("selected")
    this.$period_comparison_option.filter("[data=none]").addClass("selected")

    this.$dropdown_label.removeClass("with-data--selected")
    this.$toggle.find("i").show()
  }

  public is_selected() {
    return this.$main.hasClass("with-data--selected")
  }

  public set_availability(filter_option: string) {
    if ( filter_option === "all" ) {
      this.$main.addClass("disabled")

      this.reset()
    }
    else {
      this.$main.removeClass("disabled")
    }

    this.update_button_text()
  }

  public set_option_text(button_option_text: string, selected_period_text: string) {
    this.$period_comparison_option.each((idx, current_period_comparison_option) => {
      const $current_period_comparison_option = $(current_period_comparison_option)
      const button_default_text = $current_period_comparison_option.attr("label")
      const compare_option_value = $current_period_comparison_option.attr("data") as string

      if ( compare_option_value === "none" ) {
        return
      }

      let compare_range_details: string

      if ( button_option_text === "" || compare_option_value === "year" ) {
        compare_range_details = I18n.t(
          "apps_spacious_website_pages.building_level_real_estate_transaction_list_page.sections.compare_section.period_comparison.compare_range_details.custom_range",
          {
            selected_period: selected_period_text,
            compared_period: this.custom_compared_period_text(compare_option_value, selected_period_text.split("-")),
          }
        )
      }
      else {
        compare_range_details = I18n.t(
          "apps_spacious_website_pages.building_level_real_estate_transaction_list_page.sections.compare_section.period_comparison.compare_range_details.option",
          {
            selected_period: button_option_text,
            compared_period: button_option_text,
          }
        )
      }

      const final_text = `${button_default_text} (${compare_range_details.trim()})`

      $current_period_comparison_option.text(final_text)
      $current_period_comparison_option.data("compare-range-details", compare_range_details.trim())
    })
  }

  public update_button_text() {
    if ( this.$period_comparison_option.filter(".selected").attr("data") === "none" ) {
      this.$dropdown_label.text(this.$dropdown_label.data("default-button-text"))
    }
    else {
      this.$dropdown_label.text(this.$period_comparison_option.filter(".selected").data("compare-range-details"))
    }
  }

}

const Factory = {
  _instance: null as null | PeriodComparisonSelectMenu,

  instance(selector?: InputSelector){
    if (this._instance != null) { return this._instance }

    this._instance = this.create(selector)
    return this._instance
  },
  create(selector?: InputSelector){
    return new PeriodComparisonSelectMenu(selector)
  },
}

export {
  Factory,
  PeriodComparisonSelectMenu,
}
